import { Outlet } from "react-router-dom";
import { Container } from "../common/HtmlTags/Container/Container";
import Header from "../common/Header/Header";
import Footer from "../common/Footer/Footer";
import "./PublicLayout.css";

const PublicLayout = () => {
  return (
    <Container className="public-layout-wrapper" data-testid="public-layout-wrapper">
      <Header isPublicLayout={true} />
      <Container className="public-content-section-wrapper">
        <Outlet />
      </Container>
      <Footer />
    </Container>
  );
};

export default PublicLayout;
